<script>
import {
  trainerComputed,
  trainerMethods,
  authMethods,
  adminPanelComputed,
  adminPanelMethods,
  organizationComputed,
} from '@state/helpers';

export default {
  computed: {
    ...adminPanelComputed,
    ...trainerComputed,
    ...organizationComputed,
  },
  props: {
    activeProducts: {
      type: Number,
      required: true,
      default: 0,
    },
    totalClients: {
      type: Number,
      required: true,
      default: 0,
    },
    monthsActive: {
      type: Number,
      required: true,
      default: 0,
    },
    totalEarning: {
      type: Number,
      required: true,
      default: 0,
    },
    totalWeeksPaid: {
      type: Number,
      required: true,
      default: 0,
    },
    stripeLink: {
      type: String,
      required: true,
      default: '#',
    },
  },
  data() {
    return {};
  },
  methods: {
    ...adminPanelMethods,
    ...trainerMethods,
    ...authMethods,
    missingDataHandler() {
      window.location.href =
        'mailto:' +
        this.organizationSupportEmail +
        '?subject=' +
        this.organizationTitle +
        ' Beta - Product Management&body=What Information would you like to see in the product summary?';
    },
    toStripeDashboard() {
      this.SET_AUTH_CHECKED(false);
      window.location.href = this.stripeLink;
    },
  },
};
</script>

<template>
  <div class="summary-block-container">
    <span class="title">Your Summary</span>
    <div class="summary-block">
      <div class="row">
        <div class="col-2">
          <div class="col-9">
            <span class="subtitle">TOTAL CLIENTS</span>
            <span class="figure">{{ totalClients }}</span>
          </div>
        </div>
        <span class="divider-vertical">&nbsp;</span>
        <div class="col-2">
          <div class="col-9">
            <span class="subtitle">TOTAL EARNINGS</span>
            <div class="earnings"
              ><span class="figure">{{ totalEarning }}</span
              ><span class="currency">$</span></div
            >
          </div>
        </div>
        <span v-if="activeProducts > 0" class="divider-vertical">&nbsp;</span>
        <div class="col-2" v-if="activeProducts > 0">
          <div class="col-9">
            <span class="subtitle">TOTAL WEEKS PAID</span>
            <span class="figure">{{ totalWeeksPaid }}</span>
          </div>
        </div>
        <span v-if="activeProducts > 0" class="divider-vertical">&nbsp;</span>
        <span class="divider-vertical">&nbsp;</span>
        <div class="col-2">
          <div class="col-9">
            <span class="subtitle">ACTIVE PRODUCTS</span>
            <span class="figure">{{ activeProducts }}</span>
          </div>
        </div>
        <div class="col ml-auto">
          <BaseButton
            type="button"
            class="btn btn-secondary  btn-round"
            @click="toStripeDashboard"
          >
            Manage my Billing
          </BaseButton>
        </div>
        <div class="col ml-auto">
          <BaseButton
            type="button"
            class="btn btn-secondary  btn-round"
            @click="missingDataHandler"
          >
            Missing Data?
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.summary-block-container {
  margin-top: 7rem;
  .title {
    color: $color-black-one;
    font-size: 24px;
    font-weight: 900;
    letter-spacing: -0.466667px;
    line-height: 32px;
    margin-bottom: 2rem;
    position: absolute;
    top: -9rem;
  }
}

.summary-block {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba($color-black-wo-rgb, 0.08);
  margin-top: 2rem;
  position: relative;
  .row {
    align-items: center;
    height: 100%;
    margin-left: 0;
    margin-right: 0;
    padding: 2.5rem 2rem;
    .ml-auto {
      align-items: center;
      display: flex;
      justify-content: flex-end;
      margin-right: 3rem;
    }
    .col-2 {
      align-items: center;
      display: flex;
      //  justify-content: center;
      flex: 0 0 14.666667%;
      height: 100%;
      max-width: 14.666667%;
      .col-9 {
        display: flex;
        flex-direction: column;
        //  flex: 0 0 14.666667%;
        //  max-width: 14.666667%;
        .earnings {
          white-space: nowrap;
        }
      }
      .subtitle {
        color: $color-dark-gray-four;
        font-size: 12px;
        font-style: normal;
        font-weight: 800;
        letter-spacing: 0.1px;
        line-height: 22px;
        text-transform: uppercase;
        white-space: nowrap;
        @include calc-font-size(0.7);
      }
      .figure {
        color: $color-action;
        font-size: 36px;
        font-style: normal;
        font-weight: normal;
        letter-spacing: -2.76429px;
        line-height: 50px;
      }
      .currency {
        font-size: 1.8rem;
        margin-left: 3px;
      }
    }
  }
  .divider-vertical {
    border-left: 1px solid $color-gray;
    height: 6rem;
    opacity: 0.5;
  }
}
</style>
